import { ref as n, computed as u, watch as c, onUnmounted as I } from "vue";
import { u as M } from "./useContainerObserver-vDxyyGDS.js";
const _ = 100, x = 100;
function U(v, d = {}) {
  const {
    // Font sizing defaults
    baseSize: l = 16,
    referenceWidth: T = 1024,
    minSize: z = 12,
    maxSize: S = 24,
    titleRatio: p = 1,
    descriptionRatio: h = 0.75,
    // Container defaults
    debounceTime: F = 300,
    defaultWidth: s = _,
    defaultHeight: H = x
  } = d, { width: b, height: E } = M(v), r = n(0), f = n(0), o = n(s), m = n(H);
  let t = null;
  const W = (e) => {
    if (e <= 0) return l;
    const i = e / T * l;
    return Math.max(z, Math.min(S, i));
  }, a = u(
    () => W(o.value || s)
  ), A = u(() => a.value * p), D = u(
    () => a.value * h
  );
  return c(
    () => b.value,
    (e) => {
      e > 0 && (r.value = e);
    }
  ), c(
    () => E.value,
    (e) => {
      e > 0 && (f.value = e);
    }
  ), c(
    [() => r.value, () => f.value],
    ([e, i]) => {
      t && clearTimeout(t), (e > 0 || i > 0) && (t = setTimeout(() => {
        e > 0 && (o.value = e), i > 0 && (m.value = i);
      }, F));
    }
  ), I(() => {
    t && (clearTimeout(t), t = null);
  }), {
    // Container dimensions
    containerWidth: o,
    containerHeight: m,
    // Font sizes as numbers
    baseFontSize: a,
    titleFontSize: A,
    descriptionFontSize: D
  };
}
export {
  _ as D,
  U as u
};
